import { FC } from "react";
import { Modal, Text, Button } from "@mantine/core";

interface UnsavedChangesModalProps {
  opened: boolean;
  action: "switch" | "back";
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

/**
 * Reusable modal for handling unsaved changes
 * Supports both tab switching and navigation scenarios
 */
const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  opened,
  action,
  onSave,
  onDiscard,
  onCancel,
}) => {
  const actionText = action === "switch" ? "switching tabs" : "going back";
  const saveButtonText =
    action === "switch" ? "Save and Switch" : "Save and Back";
  const discardButtonText =
    action === "switch" ? "Discard and Switch" : "Discard and Back";

  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title="Unsaved Changes"
      styles={{
        title: { fontWeight: 700 },
      }}
    >
      <Text>
        You have unsaved changes. Do you want to save them before {actionText}?
      </Text>
      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <Button onClick={onSave}>{saveButtonText}</Button>
        <Button onClick={onDiscard} variant="outline">
          {discardButtonText}
        </Button>
        <Button onClick={onCancel} variant="outline">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default UnsavedChangesModal;
